var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"error"},[_c('b-container',[_c('h1',{staticClass:"error__title"},[_vm._v("404")]),_c('p',{staticClass:"error__text"},[_vm._v("Page not found")]),_c('b-row',{staticClass:"justify-content-center mt-5"},[_c('router-link',{staticClass:"main-button",attrs:{"to":"/"}},[_vm._v("Home page")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }